export type UISettingType = {
    useArrows: boolean
    Draggable: boolean
    Pagination: boolean
    AutoLooping: boolean
    TimeLooping: string
};

export class UISetting {
    useArrows: boolean
    Draggable: boolean
    Pagination: boolean
    autoLoop: {
        enabled: boolean
        duration: number
    }

    constructor(source: UISettingType) {
        this.useArrows = !!source.useArrows;
        this.Draggable = !!source.Draggable;
        this.Pagination = !!source.Pagination;
        this.autoLoop = {
            enabled: !!source.AutoLooping,
            duration: parseInt(source.TimeLooping)
        }
    }
}